import React, { useState } from 'react';
import { SaveButton, Toolbar, useNotify, useSaveContext } from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';
import PhoneConfirmDialog from './PhoneConfirmDialog';
import { applySaveErrors } from '../../components/SaveConfirmButton/applySaveErrors';

/**
 * Intercepta o salvar para confirmar os dígitos do número.
 *
 * O cadastro não tem pareamento por código, então esta é a única barreira
 * contra erro de digitação — e um dígito errado aqui manda dado da rede para o
 * celular de um estranho. Vale no cadastrar E no editar: trocar o número de um
 * cadastro existente tem exatamente o mesmo risco.
 */
const ConfirmSaveToolbar = () => {
  const [open, setOpen] = useState(false);
  const { save } = useSaveContext();
  const { getValues, trigger, setError } = useFormContext();
  const phone = useWatch({ name: 'phone' });
  const notify = useNotify();

  const askConfirmation = async (event: React.MouseEvent) => {
    event.preventDefault();
    const valid = await trigger();
    if (!valid) {
      notify('Confira os campos obrigatórios antes de salvar.', { type: 'warning' });
      return;
    }
    setOpen(true);
  };

  const confirm = async () => {
    setOpen(false);
    if (save) applySaveErrors(await save(getValues()), setError, notify);
  };

  return (
    <Toolbar>
      <SaveButton type="button" onClick={askConfirmation} alwaysEnable />
      <PhoneConfirmDialog
        open={open}
        phone={phone}
        onCancel={() => setOpen(false)}
        onConfirm={confirm}
      />
    </Toolbar>
  );
};

export default ConfirmSaveToolbar;
